var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    fill: "#3b5998",
    r: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.938 29v-10.875h3.625l.906-4.531h-4.532v-1.814c0-1.812.909-2.719 2.72-2.719h1.812v-4.53h-3.625c-3.33 0-5.438 2.61-5.438 6.343v2.719h-3.625v4.531h3.625v10.876h4.531z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFacebook);
export default __webpack_public_path__ + "static/media/login-facebook.334e0f6b35ca2f8324cc217b0d2b9d03.svg";
export { ForwardRef as ReactComponent };